import { gql } from '@apollo/client';

export const veinQualifierQueryResult = `
  id,
  order,
  code,
  label
`;

export const GET_VEIN_QUALIFIER = gql`
  query getVeinQualifiers($code: String, $skip: Int, $take: Int) {
    veinQualifiers(code: $code, skip: $skip, take: $take) {
      items {
        ${veinQualifierQueryResult}
      },
      totalCount
    }
  }
`;
